import { render, staticRenderFns } from "./AttributeMappingCard.vue?vue&type=template&id=9d754170&scoped=true&"
import script from "./AttributeMappingCard.vue?vue&type=script&lang=ts&"
export * from "./AttributeMappingCard.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeMappingCard.vue?vue&type=style&index=0&id=9d754170&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d754170",
  null
  
)

export default component.exports